// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--VKOxD";
export var html = "project-details-module--html--VoAwY";
export var featured = "project-details-module--featured--t+R-7";